import React, { useState, useEffect } from 'react';
// TEMPORAL 22-ago-2026: sin uso mientras el CTA de Ads Studio está oculto.
// import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './InsightsBar.module.css';

// TODO: Connect with real conversation analysis data
const AI_INSIGHTS = [
  { icon: '💰', text: '5 clientes preguntaron por precio hoy', tag: 'Oportunidad' },
  { icon: '🔥', text: '"Envío gratis" fue el tema más mencionado esta semana', tag: 'Tendencia' },
  { icon: '📈', text: 'Tus respuestas antes de 5 min convierten 3x más', tag: 'Rendimiento' },
  { icon: '🎯', text: 'Recomienda crear una promo para el producto X — 8 consultas sin cierre', tag: 'Acción sugerida' },
];

export default function InsightsBar({ hasAds, setupComplete }) {
  const { t } = useTranslation('dashboard');
  // TEMPORAL 22-ago-2026: ver comentario del CTA más abajo.
  // const navigate = useNavigate();
  const [insightIndex, setInsightIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    if (!hasAds || !setupComplete) return;
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setInsightIndex(prev => (prev + 1) % AI_INSIGHTS.length);
        setFade(true);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, [hasAds, setupComplete]);

  // Ads Studio subscriber with setup complete: show insights
  if (hasAds && setupComplete) {
    const current = AI_INSIGHTS[insightIndex];
    return (
      <div className={styles.insightsBar}>
        <div className={styles.insightsContent}>
          <div className={styles.sparkleIcon}>✨</div>
          <div className={styles.insightText}>
            <div className={styles.insightMeta}>
              <span className={styles.insightLabel}>{t('insights.label')}</span>
              <span className={styles.insightTag}>{current.tag}</span>
            </div>
            <div className={`${styles.insightMessage} ${fade ? styles.fadeIn : styles.fadeOut}`}>
              <span className={styles.insightEmoji}>{current.icon}</span>
              {current.text}
            </div>
          </div>
        </div>
        <div className={styles.dots}>
          {AI_INSIGHTS.map((_, i) => (
            <div
              key={i}
              className={`${styles.dot} ${i === insightIndex ? styles.dotActive : ''}`}
            />
          ))}
        </div>
      </div>
    );
  }

  // Non-subscriber (after setup complete): show upsell
  if (!hasAds && setupComplete) {
    return (
      <div className={styles.upsellBar}>
        <div className={styles.upsellContent}>
          <span className={styles.upsellIcon}>✨</span>
          <div>
            <div className={styles.upsellTitle}>{t('insights.upsellTitle')}</div>
            <div className={styles.upsellDescription}>{t('insights.upsellDescription')}</div>
          </div>
        </div>
        {/* TEMPORAL 22-ago-2026: Ads Studio oculto hasta terminar
            configuración y pruebas. Restaurar al activar el add-on.
            El CTA se ELIMINA, no se deja disabled: un botón muerto
            invita a tocarlo. La clave i18n `insights.upsellCta` se
            conserva en los JSON, sin usar.
            <button className={styles.upsellBtn} onClick={() => navigate('/addon')}>
              {t('insights.upsellCta')}
            </button> */}
      </div>
    );
  }

  // During onboarding: don't show anything
  return null;
}
